import { ChecklistSchema } from '../schema/checklist_schema.js';
import { MenuSchema } from '../schema/menu_schema.js';
import { TripSchema } from '../schema/trip_schema.js';
import { ShareSchema } from '../schema/share_schema.js';
import { ServiceBase } from './service_base.js';

/**
 * A service to manage checklists on the server.
 */
class TripService extends ServiceBase {
  async getTrips() {
    return (await this.tripRequest('get-trips', {})) || [];
  }

  getTripPic(picid) {
    return this.tripRequest('get-trip-pic', {
      picid,
    });
  }

  async pickLocation(data) {
    let options = await this.tripRequest(
      'pick-location',

      data
    );
    return options || {};
  }

  createTrip(data) {
    return this.tripRequest('create', data, {});
  }

  cloneTrip(data) {
    return this.tripRequest('clone', data, {});
  }

  removeTrip(id) {
    return this.tripRequest('delete', {
      id,
    });
  }

  getProperty(id, prop) {
    return this.tripRequest('get-property', {
      id,
      prop,
    });
  }

  setProperty(data) {
    return this.tripRequest('set-property', data);
  }

  getCocampers(id) {
    return this.getProperty(id, 'cocampers');
  }

  getEntities(tripId) {
    return this.tripRequest('get-entities', {
      id: tripId,
    });
  }

  learn(entityId) {
    return this.tripRequest('learn', {
      entityId,
    });
  }

  retrain(dataset) {
    return this.tripRequest('retrain', {
      dataset,
    });
  }

  // Sharing

  shareOrRevoke(data) {
    return this.tripRequest('share-or-revoke', data);
  }

  share(data) {
    return this.tripRequest('share', data);
  }

  updateShare(data) {
    return this.shareRequest('update', data);
  }

  revokeShares(inviteHashes) {
    return this.shareRequest('revoke', {
      inviteHashes,
    });
  }

  getShareInfo(inviteHash) {
    return this.shareRequest('get-trip-share-info', {
      inviteHash,
    });
  }

  acceptShare(inviteHash) {
    return this.shareRequest('accept-trip-share', { inviteHash });
  }

  rejectShare(inviteHash) {
    return this.shareRequest('reject', {
      inviteHash,
    });
  }

  // Checklist

  getChecklist(entityId) {
    return this.checklistRequest('get-items', {
      entityId,
    });
  }

  updateChecklist(entityId, diff) {
    return this.checklistRequest('update-items', {
      entityId,
      diff,
    });
  }

  packGear(entityId, list) {
    return this.checklistRequest('pack-gear', {
      entityId,
      list,
    });
  }

  // Menus

  getMenu(entityId) {
    return this.menuRequest('get-menu', {
      entityId,
    });
  }

  getFoods() {
    return this.menuRequest('get-foods');
  }

  getUnits() {
    return this.menuRequest('get-units');
  }

  addMenuItem(data) {
    return this.menuRequest('add-menu-item', data);
  }

  changeMenuItem(data) {
    return this.menuRequest('change-menu-item', data);
  }

  deleteMenu(data) {
    return this.menuRequest('delete-menu', data);
  }

  deleteMenuItem(data) {
    return this.menuRequest('delete-menu-item', data);
  }

  getSchema(data) {
    switch (data.module) {
      case 'checklist':
        return ChecklistSchema[data.action];
      case 'menu':
        return MenuSchema[data.action];
      case 'trip':
        return TripSchema[data.action];
      case 'share':
        return ShareSchema[data.action];
    }
  }
}

export { TripService };
